import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

import LoginByPhone from './loginByPhone';

class FormContent extends React.PureComponent {
    static propTypes = {};

    state = {};

    render() {
        return (
            <div className={styles.formContent}>
                <LoginByPhone />
            </div>
        );
    }
}

export default errorBoundary(FormContent);
